// extracted by mini-css-extract-plugin
module.exports = {"themeBox":"ThemeChose_style_themeBox__e-S4e","content":"ThemeChose_style_content__2XDVo","posBox":"ThemeChose_style_posBox__2YbLq","pos":"ThemeChose_style_pos__264Pi"};